var Post = require('./post')

module.exports = Backbone.Collection.extend({
	model: Post,
	url: App.mindRoot + 'posts/reported',
	parse: function(response) {
		return response.data
	}
})
